import {Feature, FeatureCollection, Point, Polygon as GEOPolygon} from 'geojson';
import Polygon from './Forbidden';
import transform from 'geojson-transformer';
import {
  fetchForbiddenAreas,
  fetchForbiddenDetail,
  unlockPolygon,
  updateForbiddenAreas
} from '../../api/operation/polygon';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';
import {LS_FORBIDDEN_STORES_KEY } from "../../utils/constants";
import Schema from "schema.io";
import * as ReactDOM from 'react-dom';
import {findInBoundary, removeById} from "../../api/operation/geojson";
import set = Reflect.set;



interface IRemoteForbidden {
  _id: string;
  path:GEOPolygon;
  state:number;
}
interface IForbiddenStore {
  polygon: Polygon;
  remote?: string;
  state?:number;
}
interface IForbiddenStoreInLocalStorage {
  points: ILngLat[];
  remote?: string;
  state?:number;
}

const forbiddenStoresSchema = new Schema([{
  points: [[Number]],
  remote: {
    type: String,
    required: false,
  },
  state: {
    type: Number,
    required: false,
  },
}]);

export default class ForbiddenAreasLoader extends SingletonEventEmitterClass {

  private _center?: ILngLat = undefined;
  private _editor?: Polygon;
  private _remoteForbiddens?: IRemoteForbidden[];
  private _forbiddenStores?: IForbiddenStore[];
  private _state:any;
  private _stateCount:number = 0;

  public geojson: FeatureCollection<GEOPolygon> = {
    type: 'FeatureCollection',
    features: [],
  };

  public get geojsonEditor(): FeatureCollection<Point> {
    if (!this._editor) {
      return {
        type: 'FeatureCollection',
        features: [],
      };
    }
    return this._editor.geojsonEditor;
  }

  public get geojsonRemotePolygons(): FeatureCollection<GEOPolygon> {
    return {
      type: 'FeatureCollection',
      features: this._remoteForbiddens!.map<Feature<GEOPolygon>>((polygon: any) => {
        return {
          type: 'Feature',
          geometry: transform(polygon.path, 'gcj02', 'wgs84'),
          properties: {
            id: polygon._id,
            info: {
              ...polygon, layerType: 'forbiddenAreas',
            },
          },
        };
      }),
    };
  }

  constructor() {
    super();
    if (ForbiddenAreasLoader.__new) {
      this._forbiddenStores = this._readFromLocalStorage();
      this._remoteForbiddens=[];
    }
  }

  private _readFromLocalStorage() {
    const data = localStorage.getItem(LS_FORBIDDEN_STORES_KEY);
    if (data) {
      try {
        const polygonStores = JSON.parse(data) as IForbiddenStoreInLocalStorage[];
        forbiddenStoresSchema.validate(polygonStores);
        return polygonStores.map(polygonStore => {
          return {
            polygon: this._newPolygon(polygonStore.points),
            remote: polygonStore.remote,
            state:polygonStore.state,
          } as IForbiddenStore;
        });
      } catch (e) {
        return [];
      }
    } else {
      return [];
    }
  }

  private _saveToLocalStorage() {
    localStorage.setItem(LS_FORBIDDEN_STORES_KEY, JSON.stringify(this._forbiddenStores!.map((forbiddenStore: IForbiddenStore) => {
          return {
            points: forbiddenStore.polygon.points,
            remote: forbiddenStore.remote,
            state:forbiddenStore.state,
          } as IForbiddenStoreInLocalStorage;
    })));
  }

  public toggleSelectPolygon(id: string) {
    const store = this._forbiddenStores!.find(forbiddenStore => {
      return (id === forbiddenStore.remote || id ===forbiddenStore.polygon.id);
    });
    if (!store) {
      console.log(store,"store");
      return;
    }
    this._editor = ((this._editor === store.polygon) || store.state) ? undefined : store.polygon;
    console.log("toggle",this._editor);
    this.refresh();
    this._triggerEditorUpdated();
  }

  public unLockPolygon(id:string){
    (async _=>{
      let result = await unlockPolygon(id,{
        state:0,
        proposedChanges: '',
        reworkReasons: [(window as any).constants.OP_POLYGON_REWORK_REASON.其他],
      });
      if (!result){
        // @ts-ignore
        window.iziToast.error({
          title: '解锁失败',
          timeout: 2000
        });
        return;
      }else{
        // @ts-ignore
        window.iziToast.success({
          title: '解锁成功',
          timeout: 2000
        });
        if (this._center) {
          this._fetchData(this._center);
          this._findForbiddens(this._center);
        }
        this._triggerUpdated();
        this._triggerRemoteForbiddensUpdated();
      }
    })()
  }

  public onMapClickedRemotePolygon(id: string) {
      const remoteForbiddens = this._remoteForbiddens!;
      const remoteForbidden = remoteForbiddens.find(polygon => polygon._id === id) as IRemoteForbidden;
      if (remoteForbidden && !remoteForbidden.state) {
        const points = [...remoteForbidden.path.coordinates[0]];
        const state = remoteForbidden.state;
        points.pop();//先将原来的点删除
        this.addPolygon(points as ILngLat[], id, state);//新增点
        remoteForbiddens.splice(remoteForbiddens.indexOf(remoteForbidden), 1);//删除原来的面
        this._triggerUpdated();
        this._triggerRemoteForbiddensUpdated();
      }else if(remoteForbidden.state){
        // @ts-ignore
        window.iziToast.info({
          title: '该区块已被锁定，请先按下U键再点击区块解锁或选择其他区块',
          color:'red',
          timeout: 5000
        });
      }
  }

  public addPolygon(points: ILngLat[], remote?: string, state?: number) {
    const polygon = this._newPolygon(points);
    const forbiddenStores = this._forbiddenStores!;
    const samePolygonStore = forbiddenStores.find(store => {
      return store.polygon.hash === polygon.hash;
    });
    if (samePolygonStore) {
      return;
    }
    this._forbiddenStores!.push({
      polygon,
      remote,
      state,
    });
    this._editor = polygon;
    this._triggerUpdated();
  }

  public refresh() {
    if (this._center) {
      this._findForbiddens(this._center);
    }
  }

  public onMapLoad(center: ILngLat) {
    // this._fetchData(center);
    this._findForbiddens(center);
  }

  private _triggerUpdated() {
    this.emit('updated');
    this._triggerEditorUpdated();
    this._saveToLocalStorage();
  }
  private _triggerEditorUpdated() {
    this.emit('forbidden_editor_updated');
  }

  private _triggerRemoteForbiddensUpdated() {
    this.emit('remote_forbiddens_updated');
  }

  private _newPolygon(points: ILngLat[]) {
    const polygon = new Polygon(points);
    polygon.on('updated', () => {
      this._triggerUpdated();
    });
    return polygon;
  }

  public onMapUpdatedCenter(center: ILngLat) {
    // this._center = center;
    // this._fetchData(center);
    // this._findForbiddens(center);


      this._center = center;
      this._fetchData(this._center);
      this._findForbiddens(this._center);

  }


  private _findForbiddens(center: ILngLat, radius?: number) {
    this.geojson = {
      type: 'FeatureCollection',
      features: this._forbiddenStores!.map(store => {
        return store.polygon.geojsonPolygon;
      }),
    }
    this._triggerRemoteForbiddensUpdated()
    this._triggerUpdated();
  }
  private _fetchData(center: ILngLat, radius?: number) {
    fetchForbiddenAreas(center, 2000).then(({ data }) => {
      const items = data;
      let remoteForbiddens:IRemoteForbidden[] = [];
      data.map(item => {
        remoteForbiddens.push({
          _id:item._id,
          path:{
            ...item.path
          },
          state:item.state
        })
      });
      this._remoteForbiddens = remoteForbiddens;

      this.geojson = {
        type: 'FeatureCollection',
        features: items.map<Feature<GEOPolygon>>(polygon => {
          return {
            type: 'Feature',
            geometry: transform(polygon.path, 'gcj02', 'wgs84'),
            properties: {
              id: polygon._id,
              info: {
                ...polygon, layerType: 'forbiddenAreas',
              },
            },
          };
        }),
      };
      this._triggerRemoteForbiddensUpdated()
      this._triggerUpdated();
    }).catch(error => {
    });
  }

  public get editingPolygon() {
    return this._editor;
  }
  public get forbiddenStoresCount() {
    return this._forbiddenStores!.length;
  }

  private get _updatedRemotePolygonIds(): string[] {
    return this._forbiddenStores!.filter(store => store.remote).map(store => store.remote!);
  }
  public cancelEditing() {
    this._editor = undefined;
    this._triggerEditorUpdated();
  }

  public async publish() {
    if (this.forbiddenStoresCount === 0) {
      return;
    }
    this._editor = undefined;
    const stores = this._forbiddenStores!;
    while (stores.length > 0) {
      const store = stores[0];
      if (store.remote) {
        await updateForbiddenAreas(store.remote, {
          path: transform(store.polygon.geometry.coordinates as ILngLat[][], 'wgs84', 'gcj02')
        }).then(res=>{
          // @ts-ignore
          window.iziToast.success({
            title: `发布成功`,
            timeout: 2000
          });
        }).catch(err=>{
          // @ts-ignore
          window.iziToast.info({
            title: `${err}`,
            color:'red',
            timeout: 2000
          });
        });
      } else {
        // await create(store.polygon.geometry.coordinates as ILngLat[][]);
      }
      stores.splice(0, 1);
      this._triggerUpdated();
    }
    if (this._center) {
      this._fetchData(this._center);
      this._findForbiddens(this._center);
    }
  }

  public async reset() {
    this._forbiddenStores = [];
    this._editor = undefined;
    this._triggerUpdated();
    if (this._center) {
      this._fetchData(this._center);
      this._findForbiddens(this._center);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/ForbiddenAreasLoader.ts